/* -----------------Child components--------------- */
import useMixedItemDist from "@hooks/useMixedItemDist";
import type { MixedItemDist } from "@memorang/types/src/tag";

const useItemsCount = (studyPackData: MixedItemDist | undefined) => {
	const { data } = useMixedItemDist();

	const isFetchingItemsCount = !data;

	let numItemsInStudyPack = 0;
	let numTopicsInStudyPack = 0;
	let numPracticeTests = 0;
	let numQuiz = 0;

	if (data || studyPackData) {
		if (studyPackData) {
			numItemsInStudyPack = studyPackData?.contents?.reduce(
				(acc, curr) => acc + curr.totalCount,
				0,
			);
			numTopicsInStudyPack = studyPackData.tags?.filter((item) =>
				item.displayType?.includes("Display"),
			)?.length;
		}

		if (data) {
			numPracticeTests = data.exams?.length
				? data.exams?.filter((exam) => {
						const isOlx =
							exam.subType === "PRACTICE_TEST" && exam.title.includes("OLX");
						return isOlx ? exam.hasAccess : exam.subType === "PRACTICE_TEST";
					})?.length
				: 0;

			numQuiz = data.exams?.length
				? data.exams?.filter(
						(exam) => exam.subType === "DIAGNOSTIC" && exam.numItems,
					)?.length
				: 0;
		}
	}

	return {
		numItemsInStudyPack,
		numPracticeTests,
		numQuiz,
		numTopicsInStudyPack,
		isFetchingItemsCount,
	};
};

export default useItemsCount;
